/**
 * Full data export (EU Data Act switching, GDPR portability): every table of the
 * workshop as CSV (for spreadsheets) and JSON (for other programs).
 */
export type ExportRow = Record<string, unknown>;

const cell = (v: unknown): string => {
  if (v === null || v === undefined) return "";
  const s = typeof v === "object" ? JSON.stringify(v) : String(v);
  return /[",\r\n]/.test(s) || /^\s|\s$/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
};

/** RFC 4180 CSV with a header of every column seen, UTF-8 BOM so spreadsheets read accents right. */
export function toCsv(rows: ExportRow[]): string {
  const columns: string[] = [];
  for (const r of rows) for (const k of Object.keys(r)) if (!columns.includes(k)) columns.push(k);
  const lines = [columns.map(cell).join(","), ...rows.map((r) => columns.map((c) => cell(r[c])).join(","))];
  return `﻿${lines.join("\r\n")}\r\n`;
}

/** File name and text of every exported table, plus a short description. */
export function exportFiles(tables: Record<string, ExportRow[]>, meta: { workshop: string; exportedAt: string; version: string }): { name: string; text: string }[] {
  const names = Object.keys(tables).sort();
  const files = names.flatMap((n) => [
    { name: `csv/${n}.csv`, text: toCsv(tables[n]!) },
    { name: `json/${n}.json`, text: `${JSON.stringify(tables[n], null, 2)}\n` },
  ]);
  const readme = [
    `Garagevo export`,
    ``,
    `Workshop: ${meta.workshop}`,
    `Exported: ${meta.exportedAt}`,
    `Format version: ${meta.version}`,
    ``,
    `csv/   one file per table, UTF-8, comma separated, first row = column names`,
    `json/  the same tables as JSON arrays`,
    `photos/ the photos in their original format (see photos.csv for what each belongs to)`,
    `signatures/ the signatures given on the phone (see work_order_signatures.csv)`,
    ``,
    `Tables: ${names.map((n) => `${n} (${tables[n]!.length})`).join(", ")}`,
  ].join("\n");
  return [{ name: "README.txt", text: `${readme}\n` }, ...files];
}

export const EXPORT_FORMAT_VERSION = "1";
